export default __webpack_public_path__ + "static/media/Growth_agent_AI.9898df6c.png";